import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type { BudgetItemConfigurationModel } from 'src/tpbp-json-api-handler/models/models'
import { BUDGET_ITEMS_ENTRY_TYPES } from 'src/tpbp-core/models/budget/budgetItem.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

const budgetItemConfigurationFields: FieldInterface[] = [
  {
    key: 'entryKind',
    originKey: 'entry_kind',
    type: FIELD_TYPES.string,
  },
  {
    key: 'entryKindLabel',
    originKey: 'entry_kind_label',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isHidden,
  },
  {
    key: 'entryKindOrder',
    originKey: 'entry_kind_order',
    type: FIELD_TYPES.number,
    rule: FIELD_RULES.isHidden,
  },
  {
    key: 'hidden',
    originKey: 'hidden',
    type: FIELD_TYPES.boolean,
    rule: FIELD_RULES.isHidden,
  },
  {
    key: 'entryCategory',
    originKey: 'entry_category',
    type: FIELD_TYPES.string,
  },
  {
    key: 'displayedCategory',
    originKey: 'entry_category_front_end',
    type: FIELD_TYPES.string,
  },
  {
    key: 'entryCategoryOrder',
    originKey: 'entry_category_order',
    type: FIELD_TYPES.number,
    isPseudoAttribute: true,
    expression: (record: BudgetItemConfigurationModel) => {
      return record._entryCategoryConfiguration?.entryCategoryOrder
    },
  },
  {
    key: 'entryType',
    originKey: 'entry_type',
    type: FIELD_TYPES.string,
    enumKeys: Object.values(BUDGET_ITEMS_ENTRY_TYPES),
  },
  {
    key: 'enums',
    originKey: 'enums',
    type: FIELD_TYPES.object,
    isMultiple: false,
    objectType: 'BudgetItemConfigurationEnums',
    objectTypePath:
      'src/services/mappings/budgetItemConfiguration/budgetItemConfiguration.types',
  },
  {
    key: 'requiredAttributes',
    originKey: 'required_attributes',
    type: FIELD_TYPES.string,
    isMultiple: true,
  },
  {
    key: 'optionalAttributes',
    originKey: 'optional_attributes',
    type: FIELD_TYPES.string,
    isMultiple: true,
  },
  {
    key: 'dependentObjects',
    originKey: 'dependent_objects',
    type: FIELD_TYPES.object,
    objectType: 'BudgetItemConfigurationDependantObject',
    objectTypePath:
      'src/services/mappings/budgetItemConfiguration/budgetItemConfiguration.types',
    isMultiple: false,
  },
]

const budgetItemConfigurationRelations: RelationInterface[] = [
  {
    key: '_entryCategoryConfiguration',
    originKey: 'entry_category_configuration',
    objectType: OBJECT_TYPES.entryCategoryConfiguration,
    isMultiple: false,
  },
]

export { budgetItemConfigurationFields, budgetItemConfigurationRelations }
